<template>
      <v-dialog
        v-model="repartDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="mdi-book-edit"
          :text="`${props.articleRepart.type=='color'?'Modification de la répartition couleur ':'Modification de la répartition de la référence '}`"
          title="Répartition"
        >
            <v-card style="overflow-y: auto;">
                <v-container class="bg-lightblue py-6" style="max-width: 500px;" >
                    <v-card elevation="2" class="pa-4" >
                    <v-card-title class="text-subtitle-1"></v-card-title>
                        <v-row dense>
                            <v-col cols="3" v-for="etab in fields">
                                <v-text-field
                                    :label="etab.code"
                                    v-model="etab.value"
                                    variant="outlined"
                                    density="compact"
                                    hide-details
                                    class="field"
                                />
                                <!-- v-model="articleRepart.art.repart[etab.code]" -->
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
          <template v-slot:actions>

            <v-card-actions >
                <v-btn
                    text="Fermer"
                    @click="repartDialog = false"
                    variant="plain"
                    color="red"
                ></v-btn>
                
                <v-btn 
                    color="success"
                    text="Valider"
                    @click="setRepart();repartDialog = false"
                    variant="plain"
                ></v-btn>
                
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>

</template>
<script setup>
    import { reactive, onMounted, ref, computed, watch, toRaw, onBeforeMount } from 'vue'
    import axios from 'axios'
    import store from '../store'
    const props = defineProps({
      article: {
        type: Object,
        required: true
      },
      articleRepart: {
        type: Object,
        required: true
      }
      
    })
    const repartDialog = defineModel()
    let fields = ref([
            { code: 'MN01', value: '' },
            { code: 'LI02', value: '' },
            { code: 'DK03', value: '' },
            { code: 'FT04', value: '' },
            { code: 'RO06', value: '' },
            { code: 'EN11', value: '' },
            { code: 'HB21', value: '' },
            { code: 'AR09', value: '' },
            { code: 'CO18', value: '' },
            { code: 'BR08', value: '' },
            { code: 'OO10', value: '' },
            { code: 'NP19', value: '' },
            { code: 'GE22', value: '' },
            { code: 'VX05', value: '' },
            { code: 'CA24', value: '' },
            { code: 'PR25', value: '' },
            { code: 'DWEB', value: '' },
            { code: 'DMIN', value: '' },
            { code: 'DMAX', value: '' }
        ])
    function convertArrayToObject(arr) {
        return arr.reduce((acc, item) => {
            acc[item.code] = item.value;
            return acc;
        }, {});
    }

        // Utilisation
    // const result = convertArrayToObject(tableau);
        // Résultat: { MN01: '', LI02: '', DK03: '', ... }
    async function getRepart(article) {
        // console.log(article);
        
        try {
            const config = { method: 'get',
                maxBodyLength: Infinity,
                url: `/cegid-api/Y2/98661025_001_PROD/api/inventory-quantities/v1?barcodes=${article?.codebarre}&fields=Replenishment`, //
                headers: { 
                    'Authorization': `Bearer ${store.state.token_y2}`, 
                    'Content-Type': 'application/json' 
                }
            }
            const response = await axios.request(config)
            if(!response.data?.[0]?.stores) return;
            // Créer un Map pour accès rapide
            const fieldMap = new Map(fields.value.map(f => [f.code, f]));
            for(const store of response.data[0].stores) {
                const warehouse = store.warehouses?.[0]?.replenishment;
                if(!warehouse) continue;
                if(store.id === 'DEPO') {
                    if(fieldMap.has('DMIN')) fieldMap.get('DMIN').value = warehouse.minimumInventoryQuantity;
                    if(fieldMap.has('DMAX')) fieldMap.get('DMAX').value = warehouse.maximumInventoryQuantity;
                } else if(fieldMap.has(store.id)) {
                    fieldMap.get(store.id).value = warehouse.minimumInventoryQuantity!=0?warehouse.minimumInventoryQuantity:null;
                }
            }
            // console.log(fields.value);
            
            return fields.value;
        } catch(error) {
            console.error('Erreur getRepart:', error);
        }
    }
    function setRepart(){
    //    console.log(store.state.articles);
        isChanged.value.repart=true
        if(props.articleRepart.type=='ref'){
            for(let cab in store.state.articles[props.article.code_marque][props.article.code_theme][props.article.reference_y2]){
                store.state.articles[props.article.code_marque][props.article.code_theme][props.article.reference_y2][cab] =
                {...store.state.articles[props.article.code_marque][props.article.code_theme][props.article.reference_y2][cab],
                    repart:convertArrayToObject(fields.value),
                    repartChanged:true
                }
                
            }
        }else{
            for(let cab in store.state.articles[props.article.code_marque][props.article.code_theme][props.article.reference_y2]){
                if(store.state.articles[props.article.code_marque][props.article.code_theme][props.article.reference_y2][cab].code_couleur==props.article.code_couleur)
                {
                    store.state.articles[props.article.code_marque][props.article.code_theme][props.article.reference_y2][cab]=
                    {...store.state.articles[props.article.code_marque][props.article.code_theme][props.article.reference_y2][cab],
                        repart:convertArrayToObject(fields.value),
                        repartChanged:true
                    }
                    
                }
            }
        }
        validerArticles ()
        
    }
    let isChanged=ref({
        repart:false
    })
    async function validerArticles () {
        let referenceCol=props.article
        let data = {articles:{...store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]},isChanged:isChanged.value,user:store.state.user}
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/articles',
        // url: 'http://localhost:8282/apimyedisac/articles',
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
        }
        // loading.value=false
        return axios.request(config)
        .then((response) => { 
            isChanged.value={
                repart:false
            }
        })
        .catch((error) => {
        });
    }
    onBeforeMount(()=>{
        getRepart(props.article)
    })
    onMounted(()=>{
        getRepart(props.article)
    })
</script>